import { memo } from "react";
import { Alert } from "antd";
import { Trans } from "react-i18next";

const MessageInfo = ({ title = "", className, ...props }) => {
  return (
    <Alert
      className={`bg-[#C2E7F4] border-[#93E3FD] mb-5 text-gray-900 ${className}`}
      message={<Trans i18nKey={title} />}
      {...props}
    />
  );
};

export default memo(MessageInfo);
